<template>
  <v-dialog v-model="show" max-width="450px">
    <div class="d-flex flex-row">
      <div
        class="flex-row-auto offcanvas-mobile w-400px w-xl-450px"
        id="kt_profile_aside"
      >
        <div class="card card-custom card-stretch">
          <div class="card-body pt-4">
            <div class="d-flex align-items-center">
              <div
                class="symbol symbol-60 symbol-xxl-100 mr-5 align-self-start align-self-xxl-center"
              >
                <div v-if="shopProduct != null"
                  class="symbol-label"
                  :style="{
                    backgroundImage: `url(${shopProduct.fullImagePath})`
                  }"
                ></div>
                <i class="symbol-badge bg-success"></i>
              </div>
              <div>
                <a
                  class="font-weight-bolder font-size-h5 text-dark-75 text-hover-primary"
                  >{{ shopProduct != null ? shopProduct.name : "" }}</a
                >
              </div>
            </div>
            <!--end::User-->
            <!--begin::Contact-->
            <div class="py-9">
              <div
                class="d-flex align-items-center justify-content-between mb-2"
              >
                <span class="font-weight-bold mr-2">{{$t('common.createdOn')}}</span>
                <a class="text-muted text-hover-primary">{{
                  shopProduct != null ? shopProduct.createDate : ""
                }}</a>
              </div>
              <div
                class="d-flex align-items-center justify-content-between mb-2"
              >
                <span class="font-weight-bold mr-2">{{$t('common.description')}}:</span>
                <a class="text-muted text-hover-primary">{{
                  shopProduct != null ? shopProduct.description : ""
                }}</a>
              </div>
              <div
                class="d-flex align-items-center justify-content-between mb-2"
              >
                <span class="font-weight-bold mr-2">{{$t('common.price')}}:</span>
                <a class="text-muted text-hover-primary">{{
                  shopProduct != null ? shopProduct.price + "€" : ""
                }}</a>
              </div>
              <div
                class="d-flex align-items-center justify-content-between mb-2"
              >
                <span class="font-weight-bold mr-2">{{$t('common.inStock')}}:</span>
                <span class="text-muted">{{
                  shopProduct != null ? shopProduct.inStock : ""
                }}</span>
              </div>
              <div
                class="d-flex align-items-center justify-content-between mb-2"
              >
                <span class="font-weight-bold mr-2">{{$t('common.restrictions')}}:</span>
                <span class="text-muted">{{
                  shopProduct != null ? shopProduct.restrictions : ""
                }}</span>
              </div>
              <div
                class="d-flex align-items-center justify-content-between mb-2"
              >
                <span class="font-weight-bold mr-2">{{$t('pages.socialPosts.likeCount')}}:</span>
                <span class="text-muted">{{
                  shopProduct != null ? shopProduct.likeCount : ""
                }}</span>
              </div>
            </div>
            <!--end::Contact-->
          </div>
        </div>
      </div>

      <!--begin::Content-->

      <!--end::Content-->
    </div>
  </v-dialog>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { mapGetters } from "vuex";

export default {
  props: {
    modal: {
      default: false
    },
    shopProduct: {
      type: Object
    },
    value: Boolean
  },

  name: "custom-page",
  data() {
    return {
      tabIndex: 0
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Shop Product" }]);
  },
  methods: {
    /**
     * Set current active on click
     * @param event
     */
    setActiveTab(event) {
      let target = event.target;
      if (!event.target.classList.contains("navi-link")) {
        target = event.target.closest(".navi-link");
      }

      const tab = target.closest('[role="tablist"]');
      const links = tab.querySelectorAll(".navi-link");
      // remove active tab links
      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove("active");
      }

      // set clicked tab index to bootstrap tab
      this.tabIndex = parseInt(target.getAttribute("data-tab"));

      // set current active tab
      target.classList.add("active");
    }
  },
  computed: {
    ...mapGetters(["currentUserPersonalInfo"]),

    getFullName() {
      return (
        this.currentUserPersonalInfo.name +
        " " +
        this.currentUserPersonalInfo.surname
      );
    },
    show: {
      get() {
        return this.value;
      },
      set(value) {
        if (!value) {
          this.$emit("input", value);
        }
      }
    }
  }
};
</script>
